<template>
	<div class="list-box-wrapper">
		<slot v-if="header" name="header">
			<div class="header">
				<div class="flex-grow-1">
					<v-icon class="mr-3" small v-text="headerIcon" />
					<span v-text="header" />
				</div>
				<slot name="header-action" />
			</div>
		</slot>
		<div v-else></div>

		<div v-if="enableSearch" class="search-subheader">
			<div class="input-box">
				<input
					v-model="searchInternal"
					type="text"
					:placeholder="searchPlaceholder"
					@input="$emit('search:update', $event.target.value)"
				/>
				<v-icon class="input-search-icon" size="14">fa-search</v-icon>
			</div>
		</div>
		<div v-else class="search-helper"></div>

		<v-list class="list-box pt-0">
			<slot name="box" :items="items">
				<v-list-item-group
					:value="value"
					class="item-list"
					multiple
					@change="$emit('select', $event)"
				>
					<template v-for="(sub, index) in _subheader">
						<slot v-if="subheader" :name="'subheader' + (index || '')">
							<v-subheader class="pt-1">
								<div class="flex-grow-1">
									<v-icon class="mr-4" small v-text="_icon[index]" />
									<span v-text="sub" />
								</div>
							</v-subheader>
						</slot>

						<slot name="list" :items="_items[index]">
							<v-list-item
								v-for="(item, i) in _items[index]"
								:key="'' + index + i"
								:value="item"
								dense
								@click="toggleIcon(item)"
							>
								<slot name="list-item" :item="item" :list="index" :index="i">
									<v-list-item-icon>
										<v-icon color="success" v-text="item.icon" />
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title v-text="item.name" />
									</v-list-item-content>
								</slot>
							</v-list-item>
						</slot>
					</template>
				</v-list-item-group>
			</slot>
		</v-list>

		<slot v-if="subtext" name="subtext">
			<span class="subtext" v-text="subtext" />
		</slot>
		<span v-else></span>
	</div>
</template>

<script>
export default {
	props: {
		header: String,
		headerIcon: String,
		subtext: String,
		subtextIcon: String,
		subheader: {
			type: [String, Array],
			default: "",
		},
		icon: {
			type: [String, Array],
			default: "",
		},
		items: {
			type: Array,
			default: () => [],
		},
		value: [String, Object, Number, Array],
		enableSearch: Boolean,
		search: String,
		searchPlaceholder: {
			type: String,
			default: "Search",
		},
		searchCompare: {
			type: Function,
			default: (item, search = "") =>
				item.name.toLowerCase().includes(search.toLowerCase()),
		},
	},

	data() {
		return {
			searchInternal: "",
		};
	},

	computed: {
		_subheader() {
			return Array.isArray(this.subheader) ? this.subheader : [this.subheader];
		},

		_icon() {
			return Array.isArray(this.icon) ? this.icon : [this.icon];
		},

		_items() {
			const items = Array.isArray(this.items[0]) ? this.items : [this.items];
			const search = this.searchInternal;
			const compareFn = this.searchCompare;
			return items.map((items) =>
				items.filter((item) => compareFn(item, search))
			);
		},
	},

	watch: {
		search(v) {
			this.searchInternal = v;
		},
	},

	created() {
		this.searchInternal = this.search;
	},

	methods: {
		toggleIcon(item) {
			item.icon = this.value.includes(item) ? "" : "fa-check";
		},
	},
};
</script>

<style lang="scss" scoped>
.list-box-wrapper {
	position: relative;
	display: grid;
	grid-template-rows: auto 1fr;
}

.search-subheader {
	position: absolute;
	margin-left: auto;
	margin-right: 16px;
	height: 0;
	width: fit-content;
	top: 6px;
	right: 1px;
	z-index: 2;
}

.search-helper {
	display: none;
}

.header {
	margin-bottom: 4px;
	display: flex;
}

.input-box {
	position: relative;
	display: flex;
	align-items: center;
	border-bottom: 1px solid rgba(0, 0, 0, 0.67);
	height: 23px;
	width: 150px;
	overflow: hidden;
	z-index: 2;
}

.input-search-icon {
	position: absolute;
	right: 0;
	padding-right: 8px;
	height: 100%;
	pointer-events: none;
}

input {
	padding: 2px 28px 2px 4px;
	width: 100%;
	outline: none;
}

.list-box {
	position: relative;
	border: 1px solid #0008;
	overflow-y: scroll;
	border-radius: 0;

	.v-subheader {
		height: 36px;
		position: sticky;
		background: white;
		top: 0;
		z-index: 1;
	}
}

.subtext {
	text-align: center;
	font-style: italic;
	font-size: 0.825rem;
	margin: 2px 0;
}

@media (max-width: 400px) {
	.list-box-wrapper {
		grid-template-rows: auto auto 1fr;
	}

	.input-box {
		width: 100%;
		border: 1px solid #0008;
		border-bottom: none;
	}

	.search-subheader {
		width: 100%;
		position: initial;
		height: auto;
	}

	.search-helper {
		// makes sure the layout doesn't break when search
		// is disabled and the viewport width is <= 400px
		display: block;
	}
}
</style>
